export default "__VITE_ASSET__B_J7IBwX__"